import React from "react";
import { Grid } from "@mui/material";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./prospects.module.scss";

export const UniPageQualityProspects = () => {
  return (
    <section className={styles.section_prospect}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_prospercts.png")}
                alt="Uni Campus"
              />
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>
              How We Find the Best Prospects for You
            </h2>
            <p className={`${styles.sub_title} font-medium`}>
              UniSearch’s state-of-the-art algorithm-driven platform screens
              through student profiles to find the prospects that best suit your
              university’s course and eligibility requirements. As we drive
              these students to your profile, we also keep an eye on student
              engagement patterns best predicting application intentions.
            </p>
            <p className={`${styles.sub_title} font-medium`}>
              This means that we give you exclusive and one-to-one access to
              best-fit students with the highest likelihood of conversion!
            </p>

            <Link legacyBehavior href="/university/booking">
              <a className={`${styles.link} btn btn-bg btn-secondary`}>
                Learn More
              </a>
            </Link>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageQualityProspects;
